module.exports = __webpack_public_path__ + "img/BOOK-TITLE-01.86c4a15a.png";